import { __ } from "@wordpress/i18n";
import { X } from "lucide-react";
import { useRulesContext } from "../../../../../hook/useRulesContext";

export default function ModalHeader() {
    const { editShortcodeData: shortcode, closeShortCodeModal } =
        useRulesContext();

    return (
        <div className="flex items-center justify-between px-6 py-6 border-b border-gray-200 bg-white sticky top-0 z-10">
            <div>
                <h2 className="text-2xl font-bold text-gray-900">
                    {shortcode
                        ? __(
                              "Edit Quantity Rule",
                              "wpbean-quantity-controls-for-woocommerce",
                          )
                        : __(
                              "Add New Quantity Rule",
                              "wpbean-quantity-controls-for-woocommerce",
                          )}
                    {shortcode && (
                        <span className="text-lg font-medium text-gray-500">
                            {" "}
                            (#{shortcode.id})
                        </span>
                    )}
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                    {__(
                        "Configure your quantity rule settings and apply options.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                </p>
            </div>
            <div className="flex items-center space-x-3">
                <button
                    onClick={() => closeShortCodeModal()}
                    className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                >
                    <X className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
}
